import { z } from 'zod'

export const bookingFormSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: z.email('Enter a valid email'),
  phoneNumber: z.string().min(10, 'Phone must be 10 digits'),
  dateOfBirth: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Enter a valid date of birth')
    .refine((s) => {
      const d = new Date(s)
      if (Number.isNaN(d.getTime())) return false
      const now = new Date()
      return d.getFullYear() >= 1900 && d <= now
    }, 'Date of birth must be in the past'),
  symptoms: z.string().min(1, 'Reason for visit is required'),
})
